// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","908":"component---src-pages-markdown-remark-frontmatter-slug-tsx"}[chunkId] + "-" + {"245":"bc14e9f8c134a8c9dc27","453":"17abfeb63230aa4ce9ce","908":"ee873808494e67d1f744"}[chunkId] + ".js";
};